import styled from 'styled-components';

import { rem, flex } from '../../core';

export const TipStyled = styled.p`
  margin: 0;
  ${flex('row', '', '')};
  svg {
    fill: ${(props) => props.theme.secondary.main};
    width: ${rem(16)};
    height: ${rem(16)};
    line-height: 1.6;
    margin-top: ${rem('2')};
    margin-right: ${rem(6)};
  }
  span {
    font-size: ${rem(13)};
    line-height: 1.6;
  }
`;
